import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsectaServiceBase } from './insecta.base.service';

@Injectable({ providedIn: 'root' })
export class OrderItemTypeService extends InsectaServiceBase {
  getRecurringOrderItemTypesConstraints(
    catalogId: string,
    orderItemTypeId: string,
    insectVariantId: string | null,
    insectGrowthStageId: string | null,
    substrateId: string | null
  ): Observable<any> {
    const paramArray: string[] = [];
    if (insectVariantId) paramArray.push(`insectVariantId=${insectVariantId}`);
    if (insectGrowthStageId) paramArray.push(`insectGrowthStageId=${insectGrowthStageId}`);
    if (substrateId) paramArray.push(`substrateId=${substrateId}`);

    let url = `/catalog/${catalogId}/orderItemType/${orderItemTypeId}/leadTime`;
    if (paramArray.length > 0) url += `?${paramArray.join(`&`)}`;

    return this.get<any>(url, `v1`);
  }

  getOrderItemConstraints(catalogId: string, orderItemId: string): Observable<any> {
    const url = `/catalog/${catalogId}/orderitem/${orderItemId}/leadtime`;
    return this.get<any>(url, `v1`);
  }
}
